export function addNavSticky() {
    let $menu = $(".main-add-menu");
    let lastScrollTop = 0;

    function stickyNav() {
        let st = window.pageYOffset || document.documentElement.scrollTop;
        if (st > lastScrollTop) {
            $menu.addClass("hide");
        } else {
            $menu.removeClass("hide");
        }
        lastScrollTop = st <= 0 ? 0 : st;
    }

    $(window).on("load scroll", function () {
        // stickyNav();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/addNavSticky.js